import * as React from "react"
import {Box, Skeleton, useTheme} from "@mui/material";
import {PieAmchartSeeker} from "@ui-seeker/core"

import {TitleWithPopover} from "@components";
import {isLoadingCommonFilters} from "@signals";
import {authorizedData} from "./@signals"


const HEIGHT = 150

export default function MarketplacesAuthorized() {
	const { palette } = useTheme()

	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!authorizedData.value.length) return <></>

	return <Box>
		<PieAmchartSeeker
			rootID="MarketplacesAuthorized"
			data={authorizedData.value}
			title={<TitleWithPopover title="Authorized Sellers" />}
			series={[{
				yField: 'isAuthorized',
				xField: "num",
				innerRadius: 60,
			}]}
			sx={{ height: HEIGHT }}
			chartProps={{
				enabledPDF: false,
				root: {
					colors: [palette.info.main, palette.primary.light]
				},
				chart: {
					horizontalLayout: true,
				},
				legend: {
					centerY: 50,
					y: 50,
					verticalLayout: true,
					labels: {
						maxWidth: 140,
						width: 140,
						oversizedBehavior: "wrap"
					},
					valueLabels: {
						textAlign: "right"
					}
				}
			}}
		/>
	</Box>
}